const rcRxPrefix = 'rc';
export const rcEventRoutes = Object.freeze({
  getRcURL: `${rcRxPrefix}-navigation-changed`,
  globalKeyboardSubscriptionChange: `${rcRxPrefix}-global-keyboard-subscription-changed`
});

export enum RemoteControlCloseTypes {
  GracefullyClosed = 0,
  VisitorCancelled = 1,
  VisitorDeclined = 2
}


